export default __webpack_public_path__ + "static/media/notebook-icon-collapse.254204f8.svg";